// src/components/PrivacyPolicy.js
import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h2>FootyTick.com – Privacy Policy</h2>

{/*<p>Effective Date: 10 February 2026</p>*/}

<p>At FootyTick.com (“we,” “our,” or “us”), your privacy is important to us. This Privacy Policy 
explains how we collect, use, and protect any personal information that you may provide when 
using our website at www.FootyTick.com (“Site”).</p>

<p>By using the Site, you consent to the practices described in this Privacy Policy.</p>

<h1>1. Information We Collect</h1>
<p>FootyTick.com is primarily an informational website. We do not require users to register or 
provide personal information to access our content. However, we may collect limited information 
in the following ways:</p>

<p>a. Automatically Collected Information
When you visit the Site, we may collect certain information automatically, including:</p>

<p>IP address</p>

<p>Browser type and version</p>

<p>Pages visited and time spent</p>

<p>Referring website</p>

<p>Device information</p>

<p>This data is collected via standard web analytics tools (e.g., Google Analytics) to help 
us understand how visitors use the Site and to improve performance.</p>

<p>b. Voluntary Information</p>
<p>If you contact us via email or through a contact form (if available), we may collect your name, 
email address, and any other information you choose to provide.</p>

<h1>2. How We Use Information</h1>
<p>We use the collected information to:</p>

<p>Analyze and improve the Site’s performance and content</p>

<p>Respond to user inquiries or feedback</p>

<p>Detect and prevent abuse or unauthorized access</p>

<p>We do not sell, rent, or trade your personal information to third parties.</p>

<h1>3. Cookies and Tracking Technologies</h1>
<p>We may use cookies or similar tracking technologies to:</p>

<p>Understand how visitors navigate the Site</p>

<p>Improve the user experience</p>

<p>Store certain preferences (such as your country or language, if applicable)</p>

<p>You can control or disable cookies through your browser settings. Disabling cookies may 
affect how some parts of the Site function.</p>

<h1>4. Third-Party Services</h1>

<p>We may use third-party services such as:</p>

<p>Google Analytics (for website analytics)</p>

<p>Web hosting providers</p>

<p>Email hosting providers</p>

<p>These third parties may collect or process data on our behalf, but they are not permitted 
to use it for their own purposes.</p>

<p>Our Site may also link to external websites. We are not responsible for the content or 
privacy practices of those sites. Please review their privacy policies before providing 
them with personal information.</p>

<h1>5. Data Security</h1>

<p>We take reasonable technical and organizational steps to protect your information from 
unauthorized access, disclosure, alteration, or destruction. However, no method of 
internet transmission or electronic storage is completely secure.</p>

<h1>6. Children’s Privacy</h1>

<p>FootyTick.com is not intended for children under the age of 13. We do not knowingly collect 
personal information from children. If you believe we have collected information from a 
child under 13, please contact us and we will promptly delete it.</p>

<h1>7. Your Rights</h1>

<p>Depending on your location, you may have certain rights regarding your personal data, 
including:</p>

<p>The right to access any data we may have about you</p>

<p>The right to request correction or deletion of your data</p>

<p>The right to opt out of data collection (e.g., through cookie settings)</p>

<p>To exercise any of these rights, contact us at: contact@footytick.com</p>

<h1>8. Changes to This Privacy Policy</h1>
<p>We may update this Privacy Policy from time to time. Changes will be posted on this page 
with an updated effective date. Continued use of the Site after any changes indicates your 
acceptance of the updated policy.</p>

<h1>9. Contact Us</h1>
<p>If you have any questions or concerns about this Privacy Policy, please contact:</p>

<p>Email: contact@footytick.com</p>

<p>Thank you for visiting FootyTick.com.</p>

    </div>
  );
};

export default PrivacyPolicy;
